<template>
  <div>
    <v-data-table
      v-model="selected"
      :show-select="totaleDati > 0"
      color="blue lighten-4"
      item-key="_id"
      :headers="headers"
      :items="datiRaw"
      :options.sync="options"
      :server-items-length="totaleDati"
      :loading="loading"
      :disable-pagination="true"
      :hide-default-footer="true"
      class="elevation-1"
      @click:row="clickRow"
      @dblclick:row="dblclickRow"
      :disable-sort="true"
      dense
    >
    <template v-slot:top>
      <v-toolbar flat>
        <v-toolbar-title>Scegli le conte inventariali da considerare per l'inventario</v-toolbar-title>
        <v-btn v-if="totaleDati > 0" class="ml-5" color="success" @click.stop="onToggleSelezione">{{ selected.length === datiRaw.length ? 'Annulla selezione' : 'Seleziona tutti' }}</v-btn>
      </v-toolbar>      
      <filtri @ricerca="onRicerca"/>
    </template>
    <template v-slot:[`item.data`]="{ item }">
      {{ item.data | date }}
    </template>
<!--     <template v-slot:[`item.actions`]="{ item }">
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="completaItem(item)" v-bind="attrs" v-on="on">mdi-wrench-outline</v-icon>
        </template>
        <span>Completa le informazioni dei prodotti</span>
      </v-tooltip>
      <v-tooltip bottom>
        <template v-slot:activator="{ on, attrs }">
          <v-icon small class="mr-2" @click="downloadItem(item)" v-bind="attrs" v-on="on">mdi-cloud-download-outline</v-icon>
        </template>
        <span>Download informazioni prodotti</span>
      </v-tooltip>
    </template> -->
    <template v-slot:no-data>
      Visualizza le letture effettuate
    </template>
    </v-data-table>
  </div>
</template>

<script>
  import _ from 'lodash'
  import magazzino from '@/services/magazzinoService'
  import Filtri from './letture_filtri'
  import excelService from '@/services/excelService'

  export default {
    components: {
      Filtri
    },
    props: {
      reload: Number
    },
    data () {
      return {
        selected: [],
        loading: true,
        options: {},
        expanded: [],
        singleExpand: false,
        editedIndex: -1,
        editedItem: null,
        datiRaw: [],
        totaleDati: 0,
        intestazioniRaw: []
      }
    },
    watch: {
      options: {
        async handler () {
          await this.getDataFromApi()
        },
        deep: true
      },
      async reload() {
        await this.getDataFromApi()
      },
      selected(value) {
        this.$emit('selezione', this.selected)
      }
    },
    computed: {
      headers() {
        return this.intestazioniColonneRaw(this.datiRaw)
      }
    },
    methods: {
      onToggleSelezione() {
        if (this.selected.length === this.datiRaw.length) {
          this.annullaSelezione()
        } else {
          this.onAggiungiTutti()
        }
      },      
      onAggiungiTutti() {
        this.selected = [...this.datiRaw]
      },      
      async onRicerca(filtri) {
        this.filtri = filtri
        await this.getDataFromApi()
      },      
      async getDataFromApi () {
        try {
          this.loading = true
          this.annullaSelezione()

          let opzioni = {
            soloNomi: true,
            itemsPerPage: 1000,
            page: 1
          }
          
          const data = await magazzino.getLettureInventario(this.filtri, opzioni)
          this.datiRaw = data && data.total_rows > 0 ? data.rows : []
          this.totaleDati = data.total_rows
        } catch(err) {
          this.datiRaw = []
          this.totaleDati = 0
        } finally {
          this.loading = false
        }
      },
      intestazioniColonneRaw(dati) {
        if (!dati || dati.length === 0) {
          return []
        }
        const riga = dati[0]
        const keys = Object.keys(riga).filter(x => x !== '_id')
        const colonne = keys.map(x => {
          return { value: x, text: x.toUpperCase() }
        })
        colonne.push({ text: 'Actions', value: 'actions', sortable: false })
        // colonne.push({ text: '', value: 'data-table-expand' })
        return colonne
      },      
      clickRow(item, options) {
      },
      dblclickRow(event, options) {
      },
      async completaItem(item) {
        // aggiunge i dettagli del prodotto in base al barcode inserito
        this.loading = true
        await magazzino.completaLetture(item._id)
        await this.getDataFromApi()
        this.loading = false
      },
      async downloadItem(item) {
        const lettura = await magazzino.downloadInfoLetture(item._id)
        if (lettura) {
          // Eventualmente passare intestazioni
          const nomefile = `${lettura.nomeFile.split('.')[0]}.xlsx`
          await excelService.creaExcelData(lettura.dati, nomefile)
        }
      },      
      annullaSelezione() {
        while(this.selected.length > 0) { this.selected.pop() }
      }    
    }
  }
</script>

<style lang="scss">
  tr.v-data-table__expanded__content  { // TODO: Solo su questa pagina !
    box-shadow: none !important;
  }
  
</style>
